import {
  HomeMultimediaAlbumListResponse,
  HomeMultimediaAlbumResponse,
  HomeMultimediaListResponse,
  HomeMultimediaResponse,
} from "@API/src/component/memoruHome/album/types";

export const isTypeHomeMultimediaAlbumListResponse = (
  arg
): arg is HomeMultimediaAlbumListResponse =>
  arg !== null &&
  typeof arg === "object" &&
  typeof (arg as HomeMultimediaAlbumListResponse).items === "object" &&
  typeof (arg as HomeMultimediaAlbumListResponse).total === "number";

export const isTypeHomeMultimediaAlbumResponse = (
  arg
): arg is HomeMultimediaAlbumResponse =>
  arg !== null &&
  typeof arg === "object" &&
  typeof (arg as HomeMultimediaAlbumResponse).albumId === "number" &&
  typeof (arg as HomeMultimediaAlbumResponse).year === "number" &&
  typeof (arg as HomeMultimediaAlbumResponse).title === "string" &&
  typeof (arg as HomeMultimediaAlbumResponse).thumbnailImage === "object" &&
  typeof (arg as HomeMultimediaAlbumResponse).availableAfter === "string";

export const isTypeHomeMultimediaListResponse = (
  arg
): arg is HomeMultimediaListResponse =>
  arg !== null &&
  typeof arg === "object" &&
  typeof (arg as HomeMultimediaListResponse).items === "object" &&
  typeof (arg as HomeMultimediaListResponse).total === "number";

export const isTypeHomeMultimediaResponse = (
  arg
): arg is HomeMultimediaResponse =>
  arg !== null &&
  typeof arg === "object" &&
  typeof (arg as HomeMultimediaResponse).multimediaId === "number" &&
  typeof (arg as HomeMultimediaResponse).category === "string" &&
  typeof (arg as HomeMultimediaResponse).date === "string" &&
  typeof (arg as HomeMultimediaResponse).thumbnailImage === "object";
